import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import Subpage_301 from "../../../modules/minds/Subpage_301";


const Page31 = () => {
  return (

    <div style={{ padding: 4}}>
      <Breadcrumb
        items={[
          { label: "accueil", href: "/HomePage" },
          { label: "project", href: "/dashboard" },
        ]}

      />
      <PageHeader
        title="Emergence"
        subtitle="Pilotez les activités des agents autonomes et analysez les résultats"
        className= "title-minds"
      />
      <hr className="page-separator" />
      {/* Contenu de la page */}
      <main
        className="content"
        style={{
          padding: 0,
          margin: 0,
          marginTop: -8,
          background: "transparent",
          boxSizing: "border-box",
        }}
      >
        <Subpage_301 />
      </main>
      
    </div>

  );
};

export default Page31;
